module.exports = __webpack_public_path__ + "portal-static/img/6.c41022d2.jpg";